import { CustomHeader } from "@/components/CustomHeader";
import { Stack } from "expo-router";
import { useTranslation } from "react-i18next";

export default function GroupsLayout() {
  const { t } = useTranslation();

  return (
    <Stack screenOptions={{ headerShown: false }}>
      <Stack.Screen
        name="index"
        options={{
          headerShown: true,
          header: () => <CustomHeader title={t("GROUPS")} type="subtitle" />,
        }}
      />
      <Stack.Screen
        name="create"
        options={{
          headerShown: true,
          header: () => (
            <CustomHeader
              title={t("CREATE_GROUP")}
              type="subtitle"
              showBackButton
            />
          ),
        }}
      />
      <Stack.Screen name="[id]" options={{ headerShown: false }} />
      <Stack.Screen name="invite" options={{ headerShown: false }} />
      <Stack.Screen name="group-info" options={{ headerShown: false }} />
    </Stack>
  );
}
